
export class RefManager {
    static refs = {};
    static storeRef(name, ref) {
        let x = { name, ref };
        this.refs[name] = x;
    }

    static getRef(name) {
        return this.refs[name].ref;
    }

    static scrollToRef(to) {
        setTimeout(() => {
            let ref = this.getRef(to);
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 10);
    }
}